// FILE: src/components/FoundingTesterBadge.js
//
// FoundingTesterBadge — the single presentational entry point for the curated
// Founding Tester recognition badge (migration 050). Two modes:
//
//   • Self-gating (auto):  <FoundingTesterBadge auto />
//        Looks up the signed-in learner's status via my_founding_tester() and
//        renders NOTHING unless they are a curated Founding Tester. Drop it on
//        any learner surface (dashboard, achievements, profile) with no props.
//
//   • Presentational:      <FoundingTesterBadge showLabel={false} size={48} />
//        Always renders the badge art (used by the Founder Wall cards).
//
// Hover text is always "Original PM Pixel Beta Contributor".
//
// No Redux. Functional component, hooks only.

import React, { useEffect, useState } from 'react';
import { getMyFoundingTester } from '../../services/foundingTesterService';
import styles from './FoundingTesterBadge.module.css';

const BADGE_ART = '/themes/pm-pixel/achievements/badge-founding-tester.png';
const HOVER_TEXT = 'Original PM Pixel Beta Contributor';

export default function FoundingTesterBadge({
  auto = false,
  size = 64,
  showLabel = true,
  label = 'Founding Tester',
  className = '',
}) {
  // In auto mode, gate render on the learner's curated status.
  const [status, setStatus] = useState(auto ? 'loading' : 'show');

  useEffect(() => {
    if (!auto) return undefined;
    let alive = true;
    getMyFoundingTester().then((row) => {
      if (alive) setStatus(row ? 'show' : 'hide');
    });
    return () => { alive = false; };
  }, [auto]);

  if (status === 'loading' || status === 'hide') return null;

  return (
    <span
      className={[styles.badge, className].filter(Boolean).join(' ')}
      title={HOVER_TEXT}
      data-testid="founding-tester-badge"
    >
      <img
        className={styles.art}
        src={BADGE_ART}
        alt={showLabel ? '' : HOVER_TEXT}
        aria-hidden={showLabel ? 'true' : undefined}
        width={size}
        height={size}
        style={{ width: size, height: size }}
        draggable="false"
      />
      {showLabel && <span className={styles.label}>{label}</span>}
      <span className={styles.tip} role="tooltip">{HOVER_TEXT}</span>
    </span>
  );
}
